import { JsonObject, ensureIsArray } from '@superset-ui/core';

export const parseJson = (json: string | undefined): JsonObject => {
  try {
    return JSON.parse(json ?? '{}');
  } catch (e) {
    return {};
  }
};

export const getFirstVizTypeFromExtraField = (
  extraField: string | undefined,
): string | null => {
  const allowList = parseJson(extraField).vizAllowList;
  return ensureIsArray(allowList).length > 0 ? allowList[0] : null;
};
